package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class PrescriptionApplicableSyndromeViscus(private val literal: String) : IEnumType {
	NA("NA"),
	心气虚证("心气虚证"),
	心血虚证("心血虚证"),
	心阳虚证("心阳虚证"),
	心阴虚证("心阴虚证"),
	心火亢盛证("心火亢盛证"),
	心脉瘀阻证("心脉瘀阻证"),
	痰迷心窍证("痰迷心窍证"),
	痰火扰心证("痰火扰心证"),
	心肾不交证("心肾不交证"),
	心脾两虚证("心脾两虚证"),
	心肺气虚证("心肺气虚证"),
	小肠实热证("小肠实热证"),
	肝气郁结证("肝气郁结证"),
	肝火上炎证("肝火上炎证"),
	肝血虚证("肝血虚证"),
	肝阴虚证("肝阴虚证"),
	肝阳上亢证("肝阳上亢证"),
	肝风内动证("肝风内动证"),
	肝郁血瘀证("肝郁血瘀证"),
	肝郁化火证("肝郁化火证"),
	肝气犯胃证("肝气犯胃证"),
	肝气乘脾证("肝气乘脾证"),
	肝胆湿热证("肝胆湿热证"),
	寒凝肝脉证("寒凝肝脉证"),
	胆郁痰扰证("胆郁痰扰证"),
	胆气虚证("胆气虚证"),
	脾气虚证("脾气虚证"),
	脾阳虚证("脾阳虚证"),
	中气下陷证("中气下陷证"),
	脾不统血证("脾不统血证"),
	脾虚湿困证("脾虚湿困证"),
	寒湿困脾证("寒湿困脾证"),
	湿热蕴脾证("湿热蕴脾证"),
	胃气虚证("胃气虚证"),
	胃阴虚证("胃阴虚证"),
	胃热证("胃热证"),
	胃寒证("胃寒证"),
	食滞胃脘证("食滞胃脘证"),
	肺气虚证("肺气虚证"),
	肺阴虚证("肺阴虚证"),
	风寒犯肺证("风寒犯肺证"),
	风热犯肺证("风热犯肺证"),
	燥邪犯肺证("燥邪犯肺证"),
	肺热壅盛证("肺热壅盛证"),
	痰热壅肺证("痰热壅肺证"),
	痰湿阻肺证("痰湿阻肺证"),
	大肠湿热证("大肠湿热证"),
	大肠津亏证("大肠津亏证"),
	肠燥津亏证("肠燥津亏证"),
	大肠虚寒证("大肠虚寒证"),
	肾气虚证("肾气虚证"),
	肾阳虚证("肾阳虚证"),
	肾阴虚证("肾阴虚证"),
	肾精不足证("肾精不足证"),
	肾不纳气证("肾不纳气证"),
	肾虚水泛证("肾虚水泛证"),
	肾气不固证("肾气不固证"),
	肾阴阳两虚证("肾阴阳两虚证"),
	膀胱湿热证("膀胱湿热证"),
	膀胱虚寒证("膀胱虚寒证"),
	三焦湿热证("三焦湿热证"),
	冲任不固证("冲任不固证"),
	肝郁脾虚证("肝郁脾虚证");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "prescription_applicable_syndrome_viscus"}
	override fun getLiteral(): String {return literal}
}
